import React, { useState, useEffect } from 'react';
import { Stack } from '@mui/material';
import useMobile from '@/hooks/useMobile';
import TicketItem from './TicketItem';
import TicketPrice from './TicketPrice';
import TicketArrow from './TicketArrow';
import useBoletiaConfig from '@/hooks/useBoletiaConfig';
import { useEvent } from '@/store';

function TicketCategory({ ticket, onTicketSelected = () => {} }) {
  const [disabled, setDisabled] = useState();
  const { availability } = ticket;
  const {
    event: {
      event: { id },
    },
  } = useEvent();

  // Se tiene para deshabailitar la funciónalidada de seleccionar mejores lugares
  const { isEventWithBestPlacesDisabled } = useBoletiaConfig();

  const onClick = () => {
    if (isEventWithBestPlacesDisabled(id)) return;
    onTicketSelected(ticket);
  };

  useEffect(() => {
    setDisabled(availability <= 0);
  }, []);

  const { isMobile } = useMobile();

  return (
    <TicketItem ticket={ticket} onClick={onClick} disabled={disabled}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={2}
        sx={{
          pr: 2,
          textAlign: 'right',
          width: isMobile ? '115px' : '125px',
          minWidth: isMobile ? '115px' : '125px',
        }}
      >
        <TicketPrice ticket={ticket} />
        {!isEventWithBestPlacesDisabled(id) && (
          <TicketArrow disabled={disabled} />
        )}
      </Stack>
    </TicketItem>
  );
}

export default TicketCategory;
